
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
  import UploadImg from '@/components/upload-img.vue';
	import Message from '@/components/message.vue';
  import {
    orderOuterlist,
    orderOuterimport,
    orderOuterimportState,
    orderOuterimportDownload,
    orderOutermodify,
    orderOuterdelete
  } from "@/api/order"
  import {
    getExpressList,
  } from '@/api/logistics';
  import{
		getSearchDate,
    nextDay
	}from "@/utils/index"
  import {
    getOssToken
  } from '@/api/user'
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      'slz-dialog': Dialog,
      UploadImg,
      Message,
    }
  })

  export default class ProductList extends Vue {
    private keyword = ''
    private shopname = ''
    private filterTime = ''
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private tablelist:any = []
    private tableloading = false
    private importShow = false
    private filelist:any = []
    private filename = ''
    private token:any = {}
    private ImportRecordId = ''
    private isexport = false
    private percentage = 0
    private filenum = 0

    private changelogisticsShow = false
    private expressList:any = []
    private OrderOuterModifyRequest:any = {
      Id:'',
      ExpressId:'',
      ExpressNo:''
    }

    private delShow = false
    private rowMsg:any = {}

    private mounted () {
      
      this.filterTime = getSearchDate(1).join('/')
      this.getList()
    }


    private async confirmDelete(){
      try{
        let res = await orderOuterdelete({
          Id:this.rowMsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.getList()
        }
      }finally{
        //
      }
    }
    private delNo(row){
      this.rowMsg = row
      this.delShow = true
    }
    private closechangelogistics(){
      this.OrderOuterModifyRequest = {
        Id:'',
        ExpressId:'',
        ExpressNo:''
      }
      this.changelogisticsShow = false
    }
    private async confirmchangelogistics(){
      if(!this.OrderOuterModifyRequest.ExpressId){
        this.$message.error('请输入物流公司')
        return
      }else if(!this.OrderOuterModifyRequest.ExpressNo){
        this.$message.error('请填写物流单号')
        return
      }
      try{
        let res = await orderOutermodify(this.OrderOuterModifyRequest)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.changelogisticsShow = false
          this.getList()
        }
      }finally{
        //
      }
    }
    private changeNo(row){
      this.changelogisticsShow = true
      for(let key in this.OrderOuterModifyRequest){
        this.OrderOuterModifyRequest[key] = row[key]
      }
      this.getExpressList()
    }
    /**
     * 物流公司
     */
    private async getExpressList() {
      try {
        const res: any = await getExpressList({});
        this.expressList = res.Result || [];
      } catch (e) {
        console.log(e)
      }
    }
    private exportlist(){
      let url = location.origin + '/provider/orderOuter/importDownload?ImportRecordId='+this.ImportRecordId
      window.open(url)
    }
    private async handleConfirmImport(){
      if(!this.filelist||!this.filelist.length){
        this.$message.error('请选择上传文件')
        return 
      }
      try{
        let data = {
          ExcelFilePath:this.filelist[0],
          ExcelFileName:this.filename
        }
        let res = await orderOuterimport(data)
        if(res.IsSuccess){
          // console.log(res.Result)
          this.ImportRecordId = res.Result.ImportRecordId
          this.isexport = true
          this.percentage = 0
          this.importloading()
        }
      }finally{
        //
      }
    }
    private async importloading(){
      try{
        let res = await orderOuterimportState({
          ImportRecordId:this.ImportRecordId
        })
        if(res.IsSuccess){
          // console.log(res)
          this.percentage = Math.floor(res.Result.CompleteCount/res.Result.ImportCount*100)
          // console.log(this.percentage)
          if(res.Result.ImportState==0){
            setTimeout(()=>{
              this.importloading()
            },500)
          }else{
            this.filenum = res.Result.FailureCount
          }
        }
      }finally{
        //
      }
    }
    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }
    private async getList(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keyword,
          ProductName:this.shopname,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.filterTime) {
          let time = this.filterTime.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
        let res = await orderOuterlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.getList()
    }
    private clearSearch(){
      this.keyword = ''
      this.shopname = ''
      this.filterTime = getSearchDate(1).join('/')
      this.doSearch()
    }
    private importfile(){
      this.importShow = true
    }
    private uploadSuc(e,name,name2){
      // console.log(e,name2)
      this.filelist = e
      this.filename = name2
    }
    private close(){
      //上传完成之前无法关闭
      if(this.isexport&&this.percentage!=100){
        this.importShow = true
        return
      }
      this.filelist = []
      this.filename = ''
      this.ImportRecordId = ''
      this.importShow = false
      this.isexport = false
      this.percentage = 0
      this.getList()
    }
    // 获取token
    private async getToken() {
      try {
        const res: any = await getOssToken({})
        this.token = {
          AccessKeySecret: res.access_key_secret,
          OSSAccessKeyId: res.access_key_id,
          SecurityToken: res.security_token
        }
      } catch (e) {
        console.error('getOssToken ===>', e)
      }
    }
  }
